<!-- Assign Session Owner Modal  -->
<p-dialog [(visible)]="showModel" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '470px'}" styleClass="no-header-modal overflow-visible"
  aria-label="assign-session-owner-dialog" data-testid="assign-session-owner-dialog">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="surface-0 p-3 flex align-items-center justify-content-between border-bottom-1 border-300" data-testid="session-owner-dialog-header">
      <h2 class="mb-0 text-sm line-height-1">{{'POS.MEMBERSHIP_ADDON.ASSIGN_SESSION_OWNER' | translate}}</h2>
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="showModel = false" 
        aria-label="close-dialog" data-testid="close-dialog-button">
      </div>
    </div>
    <!-- Header -->
    <!-- Modal Content -->
      <div *ngIf="planMaster" data-testid="session-owner-content">
        <div *ngFor="let service of planBreakUpCalculation.charging_today?.service_first_charge?.services;let n=index;"
          [hidden]="isSessionOwnerRequired(planMaster,service.id)" 
          [attr.data-testid]="'service-section-' + service.id">
          <h6 class="text-sm bg-blue-50 mb-0 p-3 border-bottom-1 border-300" [attr.data-testid]="'service-name-' + getServiceName(planMaster,service.id)">{{ getServiceName(planMaster,service.id) }}</h6>
          <div class="p-3" [attr.data-testid]="'service-owner-select-' + getServiceName(planMaster,service.id)">
            <label class="font-medium text-700 text-xs mb-2 uppercase">{{'POS.MEMBERSHIP_ADDON.SESSION_OWNER' | translate}}</label>
            <staff-selector [formGroup]="changeSessionOwnerForm"
              [controlName]="getSessionOwnerFC('service_session_owner_' + service.id)"
              [styleClass]="'w-full text-sm mt-1 align-items-center'" [placeHolder]="'common.PLACEHOLDER.SELECT' | translate"
              [filterstaff]="_sessionOwner" [id]="getSesionOwnerId(('service_session_owner_' + service.id))"
              [attr.aria-label]="'select-session-owner-' + getServiceName(planMaster,service.id)" 
              [attr.data-testid]="'select-session-owner-' + getServiceName(planMaster,service.id)">
            </staff-selector>
          </div>
        </div>
        <div *ngFor="let service of planBreakUpCalculation.charging_today?.service_non_recurring?.services;let n=index"
          [hidden]="isSessionOwnerRequired(planMaster,service.id)" 
          [attr.data-testid]="'service-section-nonrecurring-' + service.id">
          <h6 class="text-sm bg-blue-50 mb-0 p-3 border-bottom-1 border-300" [attr.data-testid]="'service-name-nonrecurring-' + getServiceName(planMaster,service.id)">{{ getServiceName(planMaster,service.id)}}</h6>
          <div class="p-3" [attr.data-testid]="'service-owner-select-nonrecurring-' + service.id">
            <label class="font-medium text-700 text-xs mb-2 uppercase">{{'POS.MEMBERSHIP_ADDON.SESSION_OWNER' | translate}}</label>
            <staff-selector [formGroup]="changeSessionOwnerForm"
              [controlName]="getSessionOwnerFC('service_session_owner_' + service.id)"
              [styleClass]="'w-full text-sm mt-1 align-items-center'" [placeHolder]="'common.PLACEHOLDER.SELECT' | translate"
              [filterstaff]="_sessionOwner" [id]="getSesionOwnerId(('service_session_owner_' + service.id))"
              [attr.aria-label]="'select-session-owner-' + getServiceName(planMaster,service.id)" 
              [attr.data-testid]="'select-session-owner-' + getServiceName(planMaster,service.id)">
            </staff-selector>
          </div>
        </div>
            <!-- Modal Footer -->
          <div class="p-3 border-top-1 border-300 flex align-items-center justify-content-between" data-testid="session-owner-dialog-footer">
            <div class="w-4">
            </div>
            <div class="w-8 text-right">
              <button (click)="selectSessionOwner()" pButton type="button" [label]="'common.PLACEHOLDER.CONTINUE' | translate" class="text-sm"
                aria-label="continue-session-owner-selection" data-testid="continue-button"></button>
            </div>

          </div>
          <!-- Modal Footer -->
      </div>
    <!-- Modal Content -->
  </ng-template>
</p-dialog>
<!-- Assign Session Owner Modal -->